import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AirportServiceComponent } from './airport-service.component';
import { TextTooltipModule } from '@lib/components';
import { TooltipDirectiveModule } from '@lib/directives';
import { StaticMsgModule } from '@lib/pipes';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';

@NgModule({
  declarations: [AirportServiceComponent],
  imports: [CommonModule, TooltipDirectiveModule, TextTooltipModule, TableSliderModule, StaticMsgModule],
  exports: [AirportServiceComponent],
})
export class AirportServiceModule {}
